import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	doneEpicLabel: {
		id: 'issue-field-epic-link.edit.option.done-epic-label',
		defaultMessage: 'Done',
		description: 'Label visible in epics list when epic is marked as done.',
	},
});
